import { defineStore } from 'pinia'

export const useSettingsStore = defineStore('settings', {
  state: (): {
    fontSize: number
    fontFamily: string
  } => {
    const cookieFontSize = useCookie('fontSize')
    const cookieFontFamily = useCookie('fontFamily')
    return {
      fontSize: cookieFontSize.value ? Number(cookieFontSize.value) : 18,
      fontFamily: cookieFontFamily.value || '"Pridi", "Lexend", sans-serif',
    }
  },
  actions: {
    increaseFontSize() {
      const cookieFontSize = useCookie('fontSize')
      this.fontSize = Math.min(this.fontSize + 1, 26)
      cookieFontSize.value = this.fontSize.toString()
    },
    decreaseFontSize() {
      const cookieFontSize = useCookie('fontSize')
      this.fontSize = Math.max(this.fontSize - 1, 12)
      cookieFontSize.value = this.fontSize.toString()
    },
    changeFontFamily(fontFamily) {
      const cookieFontFamily = useCookie('fontFamily')
      this.fontFamily = fontFamily
      cookieFontFamily.value = this.fontFamily.toString()
    },
  },
  getters: {
    getFontSize(): number {
      return this.fontSize
    },
    getFontFamily(): string {
      return this.fontFamily
    },
  },
})
